<template>
  <group :title="title">
    <repeater-group title="Bill Types" @add="() => model.bill_types.push(null)">
      <repeater v-for="(value, index) in model.bill_types" :key="index" :index="index" @remove="(index) => model.bill_types.splice(index, 1)">
        <text-input label="Value" v-model="model.bill_types[index]" />
      </repeater>
    </repeater-group>
    <text-input label="present" v-model="model.present" />
    <text-input label="scaling_factor" v-model="model.scaling_factor" />
    <text-input label="status" v-model="model.status" />
  </group>
</template>

<script>
import Group from '@/views/settings/machine-profile/Group'
import RepeaterGroup from '@/views/settings/machine-profile/RepeaterGroup'
import Repeater from '@/views/settings/machine-profile/Repeater'
import TextInput from '@/components/form/Text.vue'
import { ref, watch } from 'vue'

export default {
  name: 'BillValidator',

  components: {
    Repeater,
    RepeaterGroup,
    Group,
    TextInput,
  },

  props: ['modelValue', 'title'],

  setup(props, { emit }) {
    const model = ref(props.modelValue)

    watch(
      () => model,
      (v) => emit('update:modelValue', v)
    )

    return {
      model,
    }
  }
}
</script>

<style scoped>

</style>
